import { createActions, createReducer } from 'reduxsauce'

import ConsultaRemuneracaoADMRHService from '../../servicos/ConsultaRemuneracaoADMRHService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaRemuneracaoADMRHInicio: [],
    buscaConsultaRemuneracaoADMRHErro: ['erro'],
    buscaConsultaRemuneracaoADMRHSucesso: ['consultaRemuneracaoADMRH'],
    limpar: [],
    setConsultaRemuneracaoADMRHEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaConsultaRemuneracaoADMRH = (filtro, tipoServidor) => {
    return dispatch => {
        dispatch(Creators.buscaConsultaRemuneracaoADMRHInicio())
        let serv = new ConsultaRemuneracaoADMRHService()
        return serv
            .consultar(filtro, tipoServidor)
            .then(response => dispatch(Creators.buscaConsultaRemuneracaoADMRHSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaRemuneracaoADMRHErro(error)))
    }
}

const buscaConsultaRemuneracaoADMRHInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaRemuneracaoADMRHErro = (state = INITIAL_STATE, action) => {
    if (action.erro.response.data.mensagem.includes('Nenhum registro encontrado')) {
        return { ...state, lista: [], erro: action.erro, carregando: false }
    }
    return { ...state, erro: action.erro, carregando: false }
}

const buscaConsultaRemuneracaoADMRHSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaRemuneracaoADMRH,
        dataSincronizacaoDados: action.consultaRemuneracaoADMRH.dataSincronizacaoDados,
        carregando: false,
    }
}

const limpar = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const setConsultaRemuneracaoADMRHEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_REMUNERACAO_ADMRH_INICIO]: buscaConsultaRemuneracaoADMRHInicio,
    [Types.BUSCA_CONSULTA_REMUNERACAO_ADMRH_ERRO]: buscaConsultaRemuneracaoADMRHErro,
    [Types.BUSCA_CONSULTA_REMUNERACAO_ADMRH_SUCESSO]: buscaConsultaRemuneracaoADMRHSucesso,
    [Types.LIMPAR]: limpar,
    [Types.SET_CONSULTA_REMUNERACAO_ADMRH_ESTADO_DT]: setConsultaRemuneracaoADMRHEstadoDT,
})
